import { localeNumber } from 'src/localization/locale';

// Weekday weights are stored and sent as factors (1.2 = 120 % of an average
// day) but shown to the merchant as whole percentages, e.g. "120 %".
export function formatWeightPercent(weight: number): string {
  return localeNumber(weight, { style: 'percent', maximumFractionDigits: 0 });
}
